app.service('memberOrdersService', [
  '$http',
  function ($http) {
    var limit = 24;

    this.getOrders = function (page) {
      return $http({
        method: 'GET',
        url: '/api/orders',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        params: {
          page: page,
          limit: limit,
        },
      });
    };
  },
]);
